// extracted by mini-css-extract-plugin
module.exports = {"label":"ProductSortController_label__hZ52z","selectorWidth":"ProductSortController_selectorWidth__NLPxq"};